import { ACTIVE, getAddNetworkParams, parseChainId } from '../config/networks';

// Switch (or add) network on the given EIP-1193 provider without page refresh.
export const switchOrAddNetwork = async (provider) => {
  if (!provider || !provider.request) {
    throw new Error('No wallet provider found');
  }

  try {
    await provider.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: ACTIVE.chainIdHex }]
    });
    return { switched: true, added: false };
  } catch (switchErr) {
    // Chain not added — try adding it
    if (switchErr.code === 4902 || (switchErr.data && switchErr.data.originalError && switchErr.data.originalError.code === 4902)) {
      try {
        await provider.request({
          method: 'wallet_addEthereumChain',
          params: [getAddNetworkParams()]
        });
        return { switched: true, added: true };
      } catch (addErr) {
        throw addErr;
      }
    }
    throw switchErr;
  }
};

export const getChainIdFromProvider = async (provider) => {
  if (!provider || !provider.request) return null;
  try {
    const cid = await provider.request({ method: 'eth_chainId' });
    return parseChainId(cid);
  } catch (e) {
    return null;
  }
};
